import { Grid, Typography } from "@mui/material";
import { StandadCard } from "../../../components/Cards";
import { PageContainer } from "../../../components/container/PageContainer";
import { useAuth } from "../../../contexts/AuthProvider/AuthProvider";
import { Breadcrumb } from "../../../layout/fullLayout/breadcrumb/Breadcrumb";

export const NetworkingDashboard = () => {
  const { user } = useAuth();
  return (
    <PageContainer title="Dashboard" description="this is Starter Page">
      <Breadcrumb
        title="Dashboard"
        subtitle={`Welcome ${user.name}`}
      ></Breadcrumb>
      <Grid container spacing={0}>
        {/* ------------------------- row 1 ------------------------- */}
        <Grid item xs={12} lg={12}>
          <StandadCard heading="ABOUT CROSSROADS">
            <Typography variant="body1">
              India's trusted solution for roadside emergency
              Largest network of service provides across India, ready to help you during car breakdown.
              Breakdown Assistance, Tow Trucks, Flatbed Trucks, Garage Services all on a single platform.
            </Typography>
          </StandadCard>
        </Grid>
      </Grid>
    </PageContainer>
  );
};
